import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CardAdministrationRoutingModule } from './card-administration-routing.module';
import { LoadPageComponent } from './pages/load-page/load-page.component';
import { SaveCardPageComponent } from './pages/save-card-page/save-card-page.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedModule } from '@shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProcessConfirmationPageComponent } from './pages/process-confirmation-page/process-confirmation-page.component';

@NgModule({ declarations: [
        LoadPageComponent,
        SaveCardPageComponent,
        ProcessConfirmationPageComponent,
    ], imports: [CommonModule,
        CardAdministrationRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        MatCheckboxModule,
        SharedModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CardAdministrationModule {}
